import { wsPlayerToPlayerInList } from '@/utils/mappers';
import { Services } from '@/store/actions/api';
import { Client } from '@/services';

const cacheTTL = 60 * 60 * 1000;

const nowTTL = () => new Date().getTime();

class PlayersState {
  ttl = 0;

  season;

  players = [];

  constructor(season, players, ttl) {
    this.season = season;
    if (players) {
      this.players = players;
    }
    if (ttl) {
      this.ttl = ttl;
    }
  }
}

class VideosState {
  ttl = 0;

  videos = [];

  tagId;

  season;

  constructor(tagId, season, media, ttl) {
    this.tagId = tagId;
    this.season = season;

    if (media) {
      this.media = media;
    }
    if (ttl) {
      this.ttl = ttl;
    }
  }
}

export default {
  namespaced: true,
  state() {
    return {
      initialized: false,
      loading: {
        players: false,
        report: false,
        media: false,
      },
      filters: {
        season: new Date().getFullYear(),
      },
      playersBySeason: [],
      mediaCollection: [],
    };
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    videoLibraryPlayersNode(state, getters, rootState) {
      return state.playersBySeason.find(p => p.season === rootState.app.filters.season);
    },

    videoLibraryPlayers(state, getters) {
      return getters.videoLibraryPlayersNode ? getters.videoLibraryPlayersNode.players : [];
    },

    videoLibraryPlayersOutdated(state, getters) {
      return getters.videoLibraryPlayersNode ? getters.videoLibraryPlayersNode.ttl + cacheTTL < nowTTL() : true;
    },
  },
  mutations: {
    initialized(state, season) {
      state.playersBySeason.push( new PlayersState(season));
      state.initialized = true;
    },

    loading(state, payload) {
      state.loading = {...state.loading, ...payload };
    },

    players(state, { players, ttl }) {
      let o = state.playersBySeason.find(p => p.season === state.filters.season);
      if (o) {
        o.players = players;
        o.ttl = ttl;
      } else {
        state.playersBySeason.push(new PlayersState(state.filters.season, players, ttl));
      }
    },
    media(state, { media, ttl, tagId }) {
      let o = state.mediaCollection.find(m => m.season === state.filters.season && m.tagId === tagId );

      if (o) {
        o.media = media;
        o.ttl = ttl;
      } else {
        state.mediaCollection.push(new VideosState(tagId, state.filters.season, media, ttl));
      }
    }
  },
  actions: {
    initialize({ commit, rootState }) {
      console.info('Video Library initializing...');
      commit('initialized', rootState.app.filters.season);
      console.info('Video Library initialized.');
    },

    async fetchPlayers({state, dispatch, getters, commit, rootState }) {
      if (getters.videoLibraryPlayersOutdated && !state.loading.players) {

        commit('loading', { players: true });

        let params = {
          method: Services.BaseballPlayer.methods.GetPlayerTags.key,
          Season: rootState.app.filters.season.id,
          service: Services.BaseballPlayer.key,
        };

        const { data } = await Client({ params });

        if (data) {
          const players = data.Records.map((player) => {
            return wsPlayerToPlayerInList(player, state.filters.season);
          });

          commit('players', { players, ttl: nowTTL() });
        }

        commit('loading', { players: false });
      }
    },

    async fetchVideos({ state, commit, dispatch, getters }, tagId) {
      if (!state.loading.media) {
        commit('loading', { media: true });

        const params = {
          method: Services.BaseballPlayer.methods.GetPlayerTagVideos.key,
          service: Services.BaseballPlayer.key,
          PlayerTagID: tagId
        };

        const resp = await Client({ params });
        const media = resp.data;

        commit('media', { media, ttl: nowTTL(), tagId });
        commit('loading', { media: false });
      }
    }
  },
};
